export default __webpack_public_path__ + "static/media/icon-arrow-right.b8b9249e.svg";